const INCORRECT_TEXT = '{кратко.организация}';

export const formatSeoText = (text: string) => text.replace(INCORRECT_TEXT, '');
